import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { store, persistor } from './store/store';
import { PersistGate } from 'redux-persist/integration/react';
import { Provider } from 'react-redux';
import './css/main.css';
import { ThemeProvider } from './utils/ThemeContext';
import { PostHogProvider } from 'posthog-js/react';

const posthogEnabled = process.env.REACT_APP_PUBLIC_POSTHOG_RUNNER === 'true';
const posthogOptions = {
  api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST,
};

const root = ReactDOM.createRoot(document.getElementById('root'));

const AppWithProviders = (
  <Provider store={store}>
    <React.StrictMode>
      <PersistGate loading={null} persistor={persistor}>
        <ThemeProvider>
          <App />
        </ThemeProvider>
      </PersistGate>
    </React.StrictMode>
  </Provider>
);

root.render(
  posthogEnabled ? (
    <PostHogProvider
      apiKey={process.env.REACT_APP_PUBLIC_POSTHOG_KEY}
      options={posthogOptions}
    >
      {AppWithProviders}
    </PostHogProvider>
  ) : (
    AppWithProviders
  )
);
